import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import Navbar from "./Navbar";
import Footer from "./Footer";
import "./ViewCourseDetails.css";

export default function ViewCourseDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [batchStartDate, setBatchStartDate] = useState("");
  const API = "https://course-selling-backend-2-rr1n.onrender.com";

  useEffect(() => {
    fetchCourseDetails();
    loadRazorpayScript();
  }, [id]);

  const loadRazorpayScript = () => {
    const existingScript = document.querySelector(
      'script[src="https://checkout.razorpay.com/v1/checkout.js"]'
    );
    if (!existingScript) {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.async = true;
      document.body.appendChild(script);
    }
  };

  const getNextBatchDate = () => {
    const today = new Date();
    const nextBatch = new Date(today);
    nextBatch.setDate(today.getDate() + 4);
    return nextBatch.toLocaleDateString("en-IN", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  };

  const fetchCourseDetails = async () => {
    try {
      const token = localStorage.getItem("token");
      const headers = token ? { "x-auth-token": token } : {};
      const res = await axios.get(`${API}/api/courses/${id}`, { headers });
      setCourse(res.data);
      setBatchStartDate(getNextBatchDate());
    } catch (err) {
      console.error("Error fetching course details:", err);
      if (err.response && err.response.status === 401) {
        alert("Please login to view this course.");
        window.location.href = "/login";
      }
    } finally {
      setLoading(false);
    }
  };

  // ⭐ FULL PAYMENT FLOW ADDED HERE
  const handlePayment = async () => {
    if (!window.Razorpay) {
      alert("Razorpay SDK failed to load. Try again.");
      return;
    }

    const token = localStorage.getItem("token");
    if (!token) {
      alert("Please login to purchase the course.");
      return navigate("/login");
    }

    // 1️⃣ Create Order From Backend
    const orderRes = await axios.post(
      `${API}/api/payment/create-order`,
      { amount: course.price },
      { headers: { "x-auth-token": token } }
    );

    const order = orderRes.data.order;

    // 2️⃣ Razorpay Payment Window
    const options = {
      key: "rzp_live_RUUK4vJNXWL4ZP",
      amount: course.price * 100,
      currency: "INR",
      name: "Course Payment",
      description: course.title,
      image: "/logo192.png",

      order_id: order.id, // ⭐ MUST SEND ORDER ID

      handler: async function (response) {
        alert("Payment Successful!");

        // 3️⃣ VERIFY PAYMENT + UNLOCK COURSE
        const verifyRes = await axios.post(
          `${API}/api/payment/verify`,
          {
            razorpay_order_id: response.razorpay_order_id,
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_signature: response.razorpay_signature,
            courseId: id, // ⭐ SEND COURSE ID
          },
          {
            headers: { "x-auth-token": token },
          }
        );

        if (verifyRes.data.success) {
          alert("🎉 Course Unlocked Successfully!");
          window.location.reload();
        }
      },

      prefill: {
        name: localStorage.getItem("userName") || "User",
        email: localStorage.getItem("userEmail") || "user@example.com",
        contact: "9999999999",
      },

      theme: { color: "#0b57d0" },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  if (loading) return <p style={{ textAlign: "center" }}>Loading course...</p>;
  if (!course) return <p style={{ textAlign: "center" }}>Course not found.</p>;

  return (
    <>
      <Navbar />

      <div className="course-details-container">
        <div className="course-header">
          <div className="course-info">
            <p className="breadcrumb">Home › Certification › {course.title}</p>
            <h1 className="course-title">{course.title}</h1>
            <p className="course-description">{course.description}</p>

            {course.eligibility && (
              <div className="course-eligibility">
                <h3>Eligibility Criteria</h3>
                <p>{course.eligibility}</p>
              </div>
            )}

            <div className="course-price-section">
              {course.oldPrice && (
                <span className="old-price">₹{course.oldPrice}</span>
              )}
              <span className="new-price">₹{course.price}</span>
              <span className="gst">+ GST</span>
            </div>

            <div className="course-buttons">
              <button className="enroll-btn" onClick={handlePayment}>
                Pay Now to Enroll
              </button>

              <button
                className="enquire-btn"
                onClick={() => navigate("/contact")}
              >
                Enquire Now
              </button>
            </div>
          </div>

          <div className="course-image">
            <div className="image-wrapper">
              <img
                src={
                  course.thumbnail?.startsWith("http")
                    ? course.thumbnail
                    : `${API}${course.thumbnail}`
                }
                alt={course.title}
              />
            </div>
          </div>
        </div>

        <div className="course-footer">
          <div className="footer-item">
            <i className="icon">📅</i>
            <div>
              <p>Batch Starts On</p>
              <strong>{batchStartDate}</strong>
            </div>
          </div>

          <div className="footer-item">
            <i className="icon">⏱</i>
            <div>
              <p>Course Duration</p>
              <strong>{course.duration || "Not specified"}</strong>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}
